module.exports = __webpack_public_path__ + "static/media/IMG_4726.212c1a9c.JPG";